<template>
  <div class="customize_container">
    <div class="customize_title">
      <!-- <div class="step">Step 1</div> -->
      <div class="step_title">選擇你想要的金牌形狀</div>
    </div>
    <div class="center">
      <div class="pic_pc" v-if="deviceWidth > 768">
        <img v-for="(item, index) in goldWebImg" :key="index" :src="item.currentImage" @click="changeCustom('shape',item.name,index)" @mouseover="item.currentImage = item.hoverImage" @mouseout="onMouseout(item.name,index)"/>
      </div>
      <div class="pic_mobile" v-else>
        <img v-for="(item, index) in goldMobileImg" :key="index" v-on:click="changeCustom('shape',item.name,index)" :src="item.currentImage" @mouseover="item.currentImage = item.hoverImage" @mouseout="onMouseout(item.name,index)"/>
      </div>
    </div>
    <StepPreNext
      :hidePreButton="true"
      @nextClick="$router.push({ name: 'customize_step2' })"></StepPreNext>
  </div>
</template>

<script>
import path1 from "@/images/shape-1-gold@2x.png";
import path2 from "@/images/shape-2-gold@2x.png";
import path3 from "@/images/shape-3-gold@2x.png";
import path4 from "@/images/shape-4-gold@2x.png";
import path5 from "@/images/shape-5-gold@2x.png";
import path6 from "@/images/shape-1-mobile-gold@2x.png";
import path7 from "@/images/shape-2-mobile-gold@2x.png";
import path8 from "@/images/shape-3-mobile-gold@2x.png";
import path9 from "@/images/shape-4-mobile-gold@2x.png";
import path10 from "@/images/shape-5-mobile-gold@2x.png";
import path11 from "@/images/shape-6-gold@2x.png";
import path12 from "@/images/shape-6-mobile-gold@2x.png";
import path13 from "@/images/shape-7-gold@2x.png";
import path14 from "@/images/shape-7-mobile-gold@2x.png";
import path15 from "@/images/shape-8-gold@2x.png";
import path16 from "@/images/shape-8-mobile-gold@2x.png";
import path17 from "@/images/shape-9-gold@2x.png";
import path18 from "@/images/shape-9-mobile-gold@2x.png";
import StepPreNext from "@/components/StepPreNext.vue";

export default {
  name: "customizeStep1",
  components: {
    StepPreNext
  },
  created() {
    if (this.$store.getters.currentCustom.shape !== "") {
      this.currentShape = this.$store.getters.currentCustom.shape;
      this.goldWebImg.forEach(item => {
        if (item.name == this.$store.getters.currentCustom.shape) {
          item.currentImage = item.hoverImage;
        }
      });
      this.goldMobileImg.forEach(item => {
        if (item.name == this.$store.getters.currentCustom.shape) {
          item.currentImage = item.hoverImage;
        }
      });
    }
    this.deviceWidth = window.innerWidth;
  },
  data() {
    return {
      currentShape: "",
      deviceWidth: null,
      goldWebImg: [
        {
          name: "如意",
          currentImage: require("@/images/shape-1@2x.png"),
          defaultImage: require("@/images/shape-1@2x.png"),
          hoverImage: path1
        },
        {
          name: "葫蘆",
          currentImage: require("@/images/shape-2@2x.png"),
          defaultImage: require("@/images/shape-2@2x.png"),
          hoverImage: path2
        },
        {
          name: "春秋",
          currentImage: require("@/images/shape-3@2x.png"),
          defaultImage: require("@/images/shape-3@2x.png"),
          hoverImage: path3
        },
        {
          name: "大福",
          currentImage: require("@/images/shape-4@2x.png"),
          defaultImage: require("@/images/shape-4@2x.png"),
          hoverImage: path4
        },
        {
          name: "桃心",
          currentImage: require("@/images/shape-5@2x.png"),
          defaultImage: require("@/images/shape-5@2x.png"),
          hoverImage: path5
        },
        {
          name: "元寶",
          currentImage: require("@/images/shape-6@2x.png"),
          defaultImage: require("@/images/shape-6@2x.png"),
          hoverImage: path11
        },
        {
          name: "方框",
          currentImage: require("@/images/shape-7@2x.png"),
          defaultImage: require("@/images/shape-7@2x.png"),
          hoverImage: path13
        },
        {
          name: "圓框",
          currentImage: require("@/images/shape-8@2x.png"),
          defaultImage: require("@/images/shape-8@2x.png"),
          hoverImage: path15
        },
        {
          name: "法扇",
          currentImage: require("@/images/shape-9@2x.png"),
          defaultImage: require("@/images/shape-9@2x.png"),
          hoverImage: path17
        }
      ],
      goldMobileImg: [
        {
          name: "如意",
          currentImage: require("@/images/shape-1-mobile@2x.png"),
          defaultImage: require("@/images/shape-1-mobile@2x.png"),
          hoverImage: path6
        },
        {
          name: "葫蘆",
          currentImage: require("@/images/shape-2-mobile@2x.png"),
          defaultImage: require("@/images/shape-2-mobile@2x.png"),
          hoverImage: path7
        },
        {
          name: "春秋",
          currentImage: require("@/images/shape-3-mobile@2x.png"),
          defaultImage: require("@/images/shape-3-mobile@2x.png"),
          hoverImage: path8
        },
        {
          name: "大福",
          currentImage: require("@/images/shape-4-mobile@2x.png"),
          defaultImage: require("@/images/shape-4-mobile@2x.png"),
          hoverImage: path9
        },
        {
          name: "桃心",
          currentImage: require("@/images/shape-5-mobile@2x.png"),
          defaultImage: require("@/images/shape-5-mobile@2x.png"),
          hoverImage: path10
        },
        {
          name: "元寶",
          currentImage: require("@/images/shape-6-mobile@2x.png"),
          defaultImage: require("@/images/shape-6-mobile@2x.png"),
          hoverImage: path12
        },
        {
          name: "方框",
          currentImage: require("@/images/shape-7-mobile@2x.png"),
          defaultImage: require("@/images/shape-7-mobile@2x.png"),
          hoverImage: path14
        },
        {
          name: "圓框",
          currentImage: require("@/images/shape-8-mobile@2x.png"),
          defaultImage: require("@/images/shape-8-mobile@2x.png"),
          hoverImage: path16
        },
        {
          name: "法扇",
          currentImage: require("@/images/shape-9-mobile@2x.png"),
          defaultImage: require("@/images/shape-9-mobile@2x.png"),
          hoverImage: path18
        }
      ]
    };
  },
  methods: {
    changeCustom(key, content, index) {
      //圖形變化hover及click效果
      this.currentShape = content;
      this.goldWebImg.forEach(item => {
        item.currentImage = item.defaultImage;
      });
      this.goldMobileImg.forEach(item => {
        item.currentImage = item.defaultImage;
      });
      this.goldWebImg[index].currentImage = this.goldWebImg[index].hoverImage;
      this.goldMobileImg[index].currentImage = this.goldMobileImg[
        index
      ].hoverImage;

      if (content === "法扇") {
        this.$router.push({ name: "customize_fan" });
        return;
      }

      //step1 shape save to vuex
      let payload = {
        key: key,
        content: content
      };
      this.$store.dispatch("updateCostom", payload);

      //step2 預設值
      let componentCode = this.$store.getters.defaultComponentCodeByShape(
        content
      );
      this.$store.dispatch("updateComponentCode", componentCode);

      this.$store.dispatch("updateCostom", {
        key: "style",
        content: this.$store.getters.customizeMetalNameByComponentCode(
          componentCode
        )
      });
      this.$store.dispatch("updateCostom", {
        key: "accessory",
        content: this.$store.getters.defaultAccessoryByComponentCode(
          componentCode
        )
      });
      this.$store.dispatch("updateCostom", {
        key: "text",
        content: { ...this.$store.getters.currentCustom.text, respect: "" }
      });
    },
    onMouseout(itemName, index) {
      if (itemName !== this.currentShape) {
        this.goldWebImg[index].currentImage = this.goldWebImg[
          index
        ].defaultImage;
        this.goldMobileImg[index].currentImage = this.goldMobileImg[
          index
        ].defaultImage;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.customize_container {
  position: relative;
  margin-top: 30px;
  margin-bottom: 60px;
  /deep/ .step-pre-next {
    @include table {
      display: block;
      top: 5px;
    }
  }
}
.customize_title {
  color: $primaryDeepColor;
  font-size: 24px;
  font-family: "NotoSerifTC-Bold";
}
.center {
  z-index: 99;
  position: relative;
  margin-left: 20%;
  margin-right: 20%;
  @media all and (min-width: 1440px) {
    width: 864px;
    margin: auto;
  }
  @include table {
    z-index: 1;
    margin-top: 150px;
  }
  @include betweenPhoneTable {
    margin-left: 10%;
    margin-right: 10%;
  }
  @include phone {
    margin-left: 2%;
    margin-right: 2%;
  }
}
.pic_pc {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  img {
    width: 200px;
    height: 240px;
    padding: 10px;
  }
}
.pic_mobile {
  img {
    width: 90%;
  }
}
</style>
